import React, { memo } from "react";

// Icons (MUI v4)
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

// CSS
import styles from "./../../../../assets/css/Style.module.css";

// @Utility
import currencyFormat from "../../../../../../../@utility/numbers/currencyFormat";

const BoxCompleted = memo(({ displayAmount }) => {

    return (
        <div className={styles.boxMarginFormTop}>
            <div className={styles.boxDetailTop}>
                <div className="center">
                    {/* ใช้ Class ของไอคอนสำเร็จที่โปรเจคเก่ามีอยู่แล้ว */}
                    <CheckCircleIcon className="iconTransactionaction" />
                    
                    <div className={[styles.boxMarginTop, "boxDetailQRCodeCancelTextTitle"].join(" ")}>
                        ทำรายการสำเร็จ
                    </div>
                    
                    <div className={styles.boxMarginTop}>
                        จำนวนเงิน: 
                        <span className="textBoldHight">
                            {/* ใช้ currencyFormat ของโปรเจคเก่าเพื่อให้ตัวเลขมีลูกน้ำ 2 ตำแหน่ง */}
                            {currencyFormat(Number(displayAmount || 0), 2)}
                        </span> บาท
                        <br /><br />
                        ระบบได้รับยอดเงินของท่านแล้ว กำลังดำเนินการปรับยอดเครดิต กรุณารอสักครู่...
                    </div>
                </div>
            </div>
        </div>
    );
});

export default BoxCompleted;